<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['countries.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'COUNTRIES.COUNTRIES_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['countries.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'COUNTRIES.COUNTRIES_LIST.ADD_COUNTRY' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="countriesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Countries', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span
          *ngIf="dataItem && dataItem?.code"
          class="flag-icon"
          [ngClass]="'flag-icon-' + (dataItem?.code | lowercase)"
        ></span>

        <a href="javascript:void(0)" [routerLink]="['/settings/cities', dataItem.id]">{{ dataItem.name }}</a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="code"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.CODE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('code')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="phone_code"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.PHONE_CODE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('phone_code')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'COUNTRIES.COUNTRIES_LIST.ACTIONS' | translate }}"
      [width]="150"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['countries.show'])"
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-seo-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['countries.translations'])"
          (click)="editSeo(dataItem)"
        ></app-seo-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'COUNTRIES.COUNTRIES_LIST.UPLOAD_IMAGES' | translate"
          container="body"
          [collectionName]="'gallery'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="laravelModels.COUNTRY"
        >
        </app-media-library-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['countries.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <a
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              ['cities.index']
            )
          "
          class="btn btn-warning btn-ico"
          [routerLink]="['/settings/cities', dataItem.id]"
          [ngbTooltip]="'COUNTRIES.COUNTRIES_LIST.SHOW_CITIES' | translate"
          container="body"
        >
          <i class="fal fa-arrow-right"></i>
        </a>
        <!--        <app-activities-->
        <!--          [subjectType]="laravelModels.COUNTRY"-->
        <!--          [subjectId]="dataItem.id"-->
        <!--          [ngbTooltip]="'SHOW_ACTIVITIES' | translate"-->
        <!--          container="body"-->
        <!--        >-->
        <!--        </app-activities>-->
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
